import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './icon.magic.css.js';
import IconComponent from './icon.js';

const __vue_script__ = IconComponent;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return !_vm.displayAltText
    ? _c(
        "svg",
        _vm._b(
          {
            ref: "svg",
            staticClass: "icon",
            class: { "icon--badge": _vm.badge },
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              part: _vm.$p("icon", { "icon--badge": _vm.badge })
            }
          },
          "svg",
          _vm.attributes,
          false
        )
      )
    : _c("div", { staticClass: "alt-text", attrs: { part: "alt-text" } }, [
        _vm._v("\n    " + _vm._s(_vm.altText) + "\n")
      ])
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-3709c7aa_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-3709c7aa";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
